(() => {
  if (window.sparkAboutInitialized) return;
  window.sparkAboutInitialized = true;
  const instances = new WeakMap();
  const selector = '[data-spark-about-accordion]';
  const sections = root => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  function initialize(root) {
    sections(root).forEach(section => {
      if (instances.has(section)) return;
      const controller = new AbortController();
      instances.set(section, controller);
      const on = (element, name, fn) => element.addEventListener(name, fn, {signal:controller.signal});
      const rows = [...section.querySelectorAll('[data-about]')];
      const hover = matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
      let hoverBlockedUntil = 0;
      const setOpen = (target, open) => rows.forEach(row => {
        const expanded = row === target && open;
        row.querySelector('.accordion-toggle').setAttribute('aria-expanded', String(expanded));
        const panel = row.querySelector('.accordion-panel');
        panel.inert = !expanded;
        panel.classList.toggle('is-open', expanded);
      });
      rows.forEach(row => {
        const button = row.querySelector('.accordion-toggle');
        on(button, 'pointerenter', event => {
          if (hover.matches && event.pointerType !== 'touch' && performance.now() >= hoverBlockedUntil) setOpen(row, true);
        });
        on(button, 'click', () => {
          hoverBlockedUntil = performance.now() + 850;
          setOpen(row, button.getAttribute('aria-expanded') !== 'true');
        });
        on(row, 'keydown', event => {
          if (event.key === 'Escape') {
            hoverBlockedUntil = performance.now() + 850;
            setOpen(row, false);
            button.focus({preventScroll:true});
          }
        });
      });
      on(section, 'shopify:block:select', event => {
        const row = rows.find(row => row.dataset.blockId === event.detail.blockId);
        if (row) setOpen(row, true);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => sections(event.target).forEach(section => {
    instances.get(section)?.abort(); instances.delete(section);
  }));
})();
